import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import _throttle from "lodash.throttle";
gsap.registerPlugin(ScrollTrigger);

const deepDiveGallery = () => {

  let mq = window.matchMedia('(min-width: 1024px)')
  const galleries = document.querySelectorAll('.c-widget--dive-in-gallery');
  if(galleries) {
    galleries.forEach(gallery => {

      let trigger = gallery.querySelector('.c-dive-in-gallery__container');
      const images = gallery.querySelectorAll('.c-dive-in-gallery__col:not(.c-dive-in-gallery__col--2) .c-dive-in-gallery__image');
      const image = gallery.querySelectorAll('.c-dive-in-gallery__col--2');

      if (mq.matches === true) {
        trigger.style.setProperty('--dive-in-gallery-transform', `${window.innerHeight / 5 * -1}px`);
        trigger.style.setProperty('--dive-in-gallery-height', `${window.innerHeight}px`);
      } else {
        trigger.style.setProperty('--dive-in-gallery-transform', `${window.innerHeight / 5 * -1}px`);
        trigger.style.setProperty('--dive-in-gallery-height', `${window.innerHeight / 2}px`);
      }

      window.addEventListener('resize', _throttle(() => {
        mq = window.matchMedia('(min-width: 1024px)')

        if (mq.matches === true) {
          trigger.style.setProperty('--dive-in-gallery-transform', `${window.innerHeight / 5 * -1}px`);
          trigger.style.setProperty('--dive-in-gallery-height', `${window.innerHeight}px`);
        } else {
          trigger.style.setProperty('--dive-in-gallery-transform', `${window.innerHeight / 10 * -1}px`);
          trigger.style.setProperty('--dive-in-gallery-height', `${window.innerHeight / 2}px`);
        }
      }, 500))

      gsap.to(images, {
        ease: "none",
        opacity: 0.99,
        scrollTrigger: {
          trigger: trigger,
          pin: false,
          scrub: 0.5,
          start: "top top",
          end: "bottom bottom",
          invalidateOnRefresh: true,
          anticipatePin: 1,
          markers: false
        }
      });

      gsap.to(image, {
        ease: "none",
        scale: 0.99,
        y: 0,
        scrollTrigger: {
          trigger: trigger,
          pin: false,
          scrub: 0.5,
          start: "top top",
          end: "bottom bottom",
          invalidateOnRefresh: true,
          anticipatePin: 1,
          markers: false
        }
      });

    });
  }
}

window.addEventListener('DOMContentLoaded', deepDiveGallery);
